/**
 * DialerAuthService — operations cote auth qui ne sont pas du state React.
 *
 * 2026-06-04 (Fowler etape 5/5) — Extrait du god-context DialerContext.tsx
 * selon docs/cartography/dialer-context-dependencies.md §5.
 *
 * Responsabilite : actions transactionnelles d'authentification dialer
 * (logout cote serveur + cleanup localStorage + navigation).
 */

// @ts-ignore — api-client est en .js sans types
import { api } from '@/api/api-client';

/**
 * Deconnecte le caller :
 *   1. Invalide la session cote serveur (logoutCaller)
 *   2. Nettoie le cache localStorage (revcall_caller)
 *   3. Redirige vers /Login (QA-W6-12 : plus le site vitrine)
 *
 * Toutes les erreurs sont absorbees — l'utilisateur doit pouvoir sortir
 * meme si le serveur est down.
 */
export async function logout(): Promise<void> {
  try {
    await api.functions.invoke('logoutCaller', {});
  } catch (_e) {
    /* swallow */
  }
  try {
    localStorage.removeItem('revcall_caller');
  } catch (_e) {
    /* swallow */
  }
  window.location.href = '/Login';
}
